import Router from 'vue-router';
import index from '@/views/index';


export default new Router({
  mode: 'history',
  base: '/activities',
  routes: [
    {
      path: '/multi/:id',
      name: 'index',
      component: index,
      props: (route) => ({query: route.query.type})
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js